import { render, staticRenderFns } from "./CardsDinamic.vue?vue&type=template&id=a28c6d5a&scoped=true"
import script from "./CardsDinamic.vue?vue&type=script&lang=js"
export * from "./CardsDinamic.vue?vue&type=script&lang=js"
import style0 from "./CardsDinamic.vue?vue&type=style&index=0&id=a28c6d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28c6d5a",
  null
  
)

export default component.exports